import React, { useContext } from 'react';
import { Dialog } from 'primereact/dialog';
import { defineMessages, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { AccountContext } from '../../../components/AccountContext';

const i18nMessages = defineMessages({
  addItemBankSurveyContent: {
    id: 'menu.item-bank-management.add-itembank-survey-content',
    defaultMessage: 'Add ItemBank Survey Content',
  },
  addNewCompetency: {
    id: 'menu.item-bank-management.add-new-competency',
    defaultMessage: 'Add new Competency',
  },
  addContentToExistingCompetency: {
    id: 'menu.item-bank-management.add-content-to-existing-competency',
    defaultMessage: 'Add content to existing Competency',
  },
});

const AddItemBankSurveyContent = () => {
  const currentAccount = useContext(AccountContext);
  const { formatMessage } = useIntl();
  const history = useHistory();

  return (
    <div className="add-itembank-survey-content-dialog">
      <Dialog
        header={formatMessage(i18nMessages.addItemBankSurveyContent)}
        visible
        modal
        onHide={() => history.push(`/accounts/${currentAccount}/dashboard`)}
      >
        <div className="p-grid">
          <button
            type="button"
            onClick={() => {
              history.push(`/accounts/${currentAccount}/add-itembank-survey-content/new`);
            }}
          >
            {formatMessage(i18nMessages.addNewCompetency)}
          </button>
          <button
            type="button"
            onClick={() => {
              history.push(`/accounts/${currentAccount}/add-itembank-survey-content/update`);
            }}
          >
            {formatMessage(i18nMessages.addContentToExistingCompetency)}
          </button>
        </div>
      </Dialog>
    </div>
  );
};

export default AddItemBankSurveyContent;
